import React from "react";

class ErrorBoundaryGlobal extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false };
    }
  
    componentDidCatch(error, info) {
      // Display fallback UI
      this.setState({ hasError: true });
      // You can also log the error to an error reporting service
    //   logErrorToMyService(error, info);
    // console.log('ERRRORRRR', error, info);
    }
  
    render() {
      if (this.state.hasError) {
        // You can render any custom fallback UI
        return <h1>Något gick fel.</h1>;
      }
      return this.props.children;
    }
  }
  
  export default ErrorBoundaryGlobal;